import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { companyInfo } from '../mockData';

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Creative Background with Artistic Purple Gradient */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=2070)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/95 via-purple-800/90 to-pink-900/85"></div>
        
        {/* Artistic Patterns */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, white 2px, transparent 2px), radial-gradient(circle at 80% 80%, white 2px, transparent 2px)',
          backgroundSize: '60px 60px'
        }}></div>
        
        {/* Decorative Shapes */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-purple-400 rounded-full opacity-20 blur-3xl animate-float"></div>
        <div className="absolute bottom-32 right-20 w-48 h-48 bg-pink-400 rounded-full opacity-20 blur-3xl animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/3 right-1/4 w-24 h-24 bg-purple-300 rounded-full opacity-15 blur-2xl animate-float" style={{animationDelay: '0.5s'}}></div>
      </div>

      {/* Content with Asymmetric Layout */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Text Content - Asymmetric positioning */}
          <div className="lg:col-span-7 text-left">
            {/* Creative Typography */}
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-6 leading-none">
              <span className="block">Your</span>
              <span className="block text-purple-300">Trusted</span>
              <span className="block">Path to</span>
              <span className="block gradient-text bg-gradient-to-r from-purple-200 via-pink-200 to-purple-300" style={{
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Fulfillment
              </span>
              <span className="block text-6xl md:text-7xl">Excellence</span>
            </h1>

            <p className="text-xl md:text-2xl text-purple-100 mb-10 max-w-2xl leading-relaxed">
              From product sourcing to global delivery, <span className="font-bold text-white">{companyInfo.displayName}</span> handles your entire fulfillment chain.
            </p>

            {/* Creative CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="group relative bg-white text-purple-900 px-8 py-4 rounded-2xl font-bold text-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-2 overflow-hidden"
              >
                <span className="relative z-10">Get Free Quote</span>
                <ArrowRight size={20} className="relative z-10 group-hover:translate-x-1 transition-transform" />
                <div className="absolute inset-0 bg-gradient-to-r from-purple-100 to-pink-100 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </Link>
              <Link
                to="/services"
                className="group bg-purple-500/20 backdrop-blur-sm border-2 border-purple-300/50 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-purple-500/30 hover:border-purple-200 transition-all duration-300"
              >
                Explore Services
              </Link>
            </div>
          </div>

          {/* Decorative Side Element */}
          <div className="lg:col-span-5 relative hidden lg:block">
            <div className="relative w-full h-96">
              {/* Abstract Shapes */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-400 to-pink-400 rounded-3xl rotate-12 opacity-30 blur-xl animate-float"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full opacity-40 blur-2xl animate-float" style={{animationDelay: '0.7s'}}></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 border-4 border-purple-300/30 rounded-3xl rotate-45"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Artistic Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/50 rounded-full animate-pulse"></div>
          </div>
          <span className="text-white/70 text-sm font-medium">Scroll</span>
        </div>
      </div>
    </div>
  );
};

export default Hero;
